import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react'
import { routes } from '../../../utils/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { instagramExchangeTokenAction } from '../../../redux/actions/MapCheckInDashboardAction';

const InstagramConnectSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const hasCalledAPI = useRef(false);

    const workspaceId = localStorage.getItem("activeWorkspaceId");

    useEffect(() => {
        // Extract tokens immediately to avoid stale closures
        const bridgeToken = searchParams.get('bridge_token');
        const code = searchParams.get('code');


        // Prevent multiple API calls
        if (hasCalledAPI.current) {
            return;
        }

        // for fetch Instagram business pages
        if (bridgeToken && code && workspaceId) {
            hasCalledAPI.current = true;
            const fromOnboarding = localStorage.getItem("from_onboarding") === "true";
            const targetRoute = fromOnboarding ? `${routes.onboarding}/connect-socials` : routes?.businessdashboard;

            dispatch(instagramExchangeTokenAction({ bridge_token: bridgeToken, code: code, workspaceId: workspaceId || "" }))
                .unwrap()
                .then((res) => {
                    localStorage.removeItem("from_onboarding");
                    if (res.success) {
                        navigate(targetRoute, {
                            replace: true,
                            state: { fromInstagramOAuth: true, isDirect: true }
                        });
                    } else {
                        navigate(targetRoute, { replace: true });
                    }
                })
                .catch((e) => {
                    console.error("API Error:", e);
                    hasCalledAPI.current = false; // Reset on error to allow retry
                    localStorage.removeItem("from_onboarding");
                    navigate(targetRoute, { replace: true });
                });
        } else {
            const fromOnboarding = localStorage.getItem("from_onboarding") === "true";
            const targetRoute = fromOnboarding ? `${routes.onboarding}/connect-socials` : routes?.businessdashboard;
            localStorage.removeItem("from_onboarding");
            navigate(targetRoute, { replace: true });
        }

    }, [searchParams, navigate, dispatch]);

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f4f6f8',
            }}
        >
            <CircularProgress size={60} thickness={5} />
            <Typography mt={2} variant="h6" sx={{ color: '#555' }}>
                Authenticating Instagram...
            </Typography>
        </Box>
    )
}

export default InstagramConnectSuccess
